export function CustomNotes({  
  title_text,
  unit_model_name,
  unit_info,
  notes,
  created_at
}) {
  const formattedDate = created_at
    ? new Date(created_at).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" })
    : "";
  return (
    <div className="w-full">
      <div className="p-3 rounded-lg border border-gray-200 bg-gray-50 shadow-sm flex flex-col justify-start h-[150px]">
        
        {/* Header: Title & Model */}
        <div className="flex justify-between items-start mb-1">
          <div className="text-xs text-gray-500 font-semibold truncate max-w-[60%]">
            {title_text || <span className="italic text-gray-400">No Title</span>}
          </div>
          <div className="text-xs text-gray-500 font-semibold truncate max-w-[35%] text-right">
            {unit_model_name || <span className="italic text-gray-400">N/A</span>}
          </div>
        </div>

        {/* Unit Info */}
        <div className="text-sm text-gray-700 font-medium mb-1 truncate">
          {unit_info || <span className="italic text-gray-400">No Info</span>}
        </div>

        {/* Notes */}
        <div className="flex-1 overflow-y-auto text-sm text-gray-800 p-2 bg-white rounded-md border border-gray-200 break-words whitespace-pre-wrap">
          {notes ? notes : <span className="italic text-gray-400">No content</span>}
        </div>

        {/* Created At */}
        {formattedDate && (
          <div className="text-xs text-gray-400 text-right">
            {formattedDate}
          </div>
        )}
      </div>
    </div>
  );
}